import o from"color";const r=r=>o(r).hex();export{r as colorToHex};